"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _clsx = _interopRequireDefault(require("clsx"));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      height: 58,
      flex: 1,
      borderRadius: 6
    },
    label: theme.typography.h5
    // a CSS only ripple animation in case we need to fallback to it, MUIs is CSS and JS
    // ripple: {
    // backgroundPosition: 'center',
    // transition: 'background 0.8s',
    // "&:hover": {
    //   background: '#3360ff radial-gradient(circle, transparent 1%, #3360ff 1%) center/15000%'
    // },
    // "&:active": {
    //   backgroundColor: '#2253ff',
    //   backgroundSize: '100%',
    //   transition: 'background 0s'
    // }
    // }
  };
});

/**
 *
 * A default VNButton that is set to our VN Style and design.
 * @props
 *
 * Required
 * text: String - The button text
 * buttonVariant: String - any button style inside the custom object inside of the Theme chosen in VNThemes can be chosen. 
 *
 * Optional
 * onClick: func - Called when the button is clicked
 * fullWidth: Bool - Default true - Set the button to be full width or not
 * variant: String - Default 'contained' - Options are 'contained', 'text', 'outlined' | This will blend with the buttonVariant
 * color: String - Default 'primary' - Options are 'default', 'inherit', 'primary', 'secondary'
 */
var VNButton = function VNButton(props) {
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    classes: {
      label: (0, _clsx.default)(props.label && props.label)
    },
    disableRipple: props.disableRipple ? props.disableRipple : false,
    disabled: props.disabled ? props.disabled : false,
    onClick: props.onClick ? props.onClick : function () {},
    fullWidth: props.fullWidth ? props.fullWidth : true,
    variant: props.variant ? props.variant : 'contained',
    color: props.color ? props.color : 'primary',
    className: classes.button,
    style: theme.custom[props.buttonVariant]
  }, props.text);
};
exports.VNButton = VNButton;